import React, { useState } from 'react';
import { Row } from 'react-bootstrap';
import { Switch } from '../../../../../components/atoms';

const Feature = props => {
    const [ features, setFeatures ] = useState({
        bag:false,
        roundtrip:false
    });

    const onChangeFeature = (type) => {
        setFeatures({
            ...features, 
            [type]:!features[type]
        })
        props.onChange({
            ...features, 
            [type]:!features[type],
            courier:'lalamove',
            service:props.service
        })
    }

    let roundtrip,bag;
    if (props.service === 'motorcycle') {
        roundtrip = (
            <div className="justify-content-between align-items-center d-flex py-1">
                <div>
                    Perjalanan Pulang-Pergi <b>(+ Rp 10.000)</b>
                </div>
                <Switch 
                    id={'roundtrip'}
                    onChange={() => onChangeFeature('roundtrip')}
                    checked={features.roundtrip}
                />
            </div>
        );

        bag = (
            <div className="justify-content-between align-items-center d-flex py-1">
                Menggunakan LALABAG
                <Switch 
                    id={'bag'}
                    onChange={() => onChangeFeature('bag')}
                    checked={features.bag}
                />
            </div>
        );

        return (
            <div className="card px-4">
                { roundtrip }
                { bag }
            </div>
        )
    }
    return null
}

export default Feature;